export default __webpack_public_path__ + "static/media/mobilityIconEmpty.be7d20eb.svg";